export default __webpack_public_path__ + "static/media/main_l.f2c8b45b.jpg";